// import { Component } from '@angular/core';
// import { RouterOutlet } from '@angular/router';

// import { LayoutComponent, NavLink } from 'shared-frontend';
// import { HeaderComponent, FooterComponent, NavBarComponent } from 'shared-frontend';
// import { LayoutAssets } from 'shared-frontend';
// import { PERMISSION_SETS } from './core/auth/roles.constants';

// @Component({
//   selector: 'app-root',
//   standalone: true,
//   imports: [RouterOutlet, LayoutComponent],
//   templateUrl: './app.component.html',
//   styleUrl: './app.component.css'
// })
// export class AppComponent {
//   navLinks: NavLink[] = [
//     { label: 'Home', route: '/home', icon: 'glyphicon glyphicon-home', roles: PERMISSION_SETS.ADMIN },
//     { label: 'Administration', route: '/event-submission/list', icon: '', roles: PERMISSION_SETS.ADMIN },
//     { label: 'Whoami', route: '/whoami', roles: PERMISSION_SETS.SANDRA  },
//   ];

//   assets: LayoutAssets = {
//     banner: 'https://ffustorageacct.blob.core.windows.net/presform-net/BLM.jpg',
//     bannerHeight: '240px',
//     navBarIcon: 'https://ffustorageacct.blob.core.windows.net/presform-net/pres_seal.png'
//   };
// }

import { Component, DestroyRef, inject, signal } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { LayoutAssets, LayoutComponent, NavLink } from 'shared-frontend';
import { PERMISSION_SETS } from './core/auth/roles.constants';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  private router     = inject(Router);
  private destroyRef = inject(DestroyRef);

  isPrintView = signal(this.isPrintUrl(window.location.pathname));

  navLinks: NavLink[] = [
    { label: 'Home', route: '/home', icon: 'glyphicon glyphicon-home', roles: PERMISSION_SETS.ADMIN },
    { label: 'Administration', route: '/event-submission/list', icon: '', roles: PERMISSION_SETS.ADMIN },
    { label: 'Whoami', route: '/whoami', roles: PERMISSION_SETS.SANDRA  },
  ];

  assets: LayoutAssets = {
    banner: 'https://ffustorageacct.blob.core.windows.net/presform-net/BLM.jpg',
    bannerHeight: '240px',
    navBarIcon: 'https://ffustorageacct.blob.core.windows.net/presform-net/pres_seal.png'
  };

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationStart => event instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(event => this.isPrintView.set(this.isPrintUrl(event.url)));
  }

  private isPrintUrl(url: string): boolean {
    return url.split('?')[0].includes('/event-submission/print/');
  }
}
